(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-wizard"] && !Shopify.designMode) return;
  try {
    
(function(){

  var bbDataEl = document.getElementById('bb-wizard-data');
  var bbData = bbDataEl ? JSON.parse(bbDataEl.textContent) : { bouquets: [], customBouquets: [], addons: [] };
  var BOUQUETS = bbData.bouquets;
  var BOUQUETS_CUSTOM = bbData.customBouquets || [];
  var DELIVERY_FEE_VARIANTS = {
    5: 49663613468910,
    13: 49663613501678,
    14: 49663613534446,
    16: 49663613567214,
    18: 49663613599982,
    19: 49663613632750,
    20: 49663613665518,
    25: 49663613698286,
    26: 49663613731054,
    30: 49663613763822
  };
  var ADDONS = bbData.addons;
  var FREQUENCIES = [
    { id:'weekly', name:'Every week', eyebrow:'A weekly joy', desc:'Fresh beauty, week after week.', discount:0.15 },
    { id:'biweekly', name:'Every 2 weeks', eyebrow:'A little often', desc:'Something lovely, twice a month.', discount:0.10 },
    { id:'monthly', name:'Every 4 weeks', eyebrow:'A monthly moment', desc:'A beautiful monthly ritual.', discount:0.05 }
  ];
  var BLUSH_DATES_DISCOUNT = 0.05;
  var TIERS = [
    { n:3, eyebrow:'A little introduction' },
    { n:6, eyebrow:'A lovely habit' },
    { n:12, eyebrow:'A yearly devotion' }
  ];
  var POSTAL_ZONES = {
    'L0G': { zone: 'DELIVERY $20', fee: 20 },
    'L0J': { zone: 'DELIVERY $18', fee: 18 },
    'L0L': { zone: 'DELIVERY $30', fee: 30 },
    'L0P': { zone: 'DELIVERY $20', fee: 20 },
    'L0R': { zone: 'DELIVERY $25', fee: 25 },
    'L1K': { zone: 'DELIVERY $25', fee: 25 },
    'L1P': { zone: 'DELIVERY $20', fee: 20 },
    'L1S': { zone: 'DELIVERY $20', fee: 20 },
    'L1T': { zone: 'DELIVERY $20', fee: 20 },
    'L1V': { zone: 'DELIVERY $20', fee: 20 },
    'L1X': { zone: 'DELIVERY $20', fee: 20 },
    'L1Y': { zone: 'DELIVERY $20', fee: 20 },
    'L1Z': { zone: 'DELIVERY $20', fee: 20 },
    'L3P': { zone: 'DELIVERY $18', fee: 18 },
    'L3R': { zone: 'DELIVERY $18', fee: 18 },
    'L3S': { zone: 'DELIVERY $18', fee: 18 },
    'L3T': { zone: 'DELIVERY $18', fee: 18 },
    'L3X': { zone: 'DELIVERY $18', fee: 18 },
    'L3Y': { zone: 'DELIVERY $26', fee: 26 },
    'L4A': { zone: 'DELIVERY $18', fee: 18 },
    'L4B': { zone: 'DELIVERY $18', fee: 18 },
    'L4C': { zone: 'DELIVERY $18', fee: 18 },
    'L4E': { zone: 'DELIVERY $18', fee: 18 },
    'L4G': { zone: 'DELIVERY $18', fee: 18 },
    'L4H': { zone: 'DELIVERY $18', fee: 18 },
    'L4J': { zone: 'DELIVERY $18', fee: 18 },
    'L4K': { zone: 'DELIVERY $18', fee: 18 },
    'L4L': { zone: 'DELIVERY $18', fee: 18 },
    'L4M': { zone: 'DELIVERY $30', fee: 30 },
    'L4N': { zone: 'DELIVERY $25', fee: 25 },
    'L4S': { zone: 'DELIVERY $18', fee: 18 },
    'L4T': { zone: 'DELIVERY $18', fee: 18 },
    'L4V': { zone: 'DELIVERY $18', fee: 18 },
    'L4W': { zone: 'DELIVERY $18', fee: 18 },
    'L4Y': { zone: 'DELIVERY $18', fee: 18 },
    'L4Z': { zone: 'DELIVERY $18', fee: 18 },
    'L5A': { zone: 'DELIVERY $18', fee: 18 },
    'L5B': { zone: 'DELIVERY $18', fee: 18 },
    'L5C': { zone: 'DELIVERY $18', fee: 18 },
    'L5E': { zone: 'DELIVERY $18', fee: 18 },
    'L5G': { zone: 'DELIVERY $18', fee: 18 },
    'L5H': { zone: 'DELIVERY $18', fee: 18 },
    'L5J': { zone: 'DELIVERY $18', fee: 18 },
    'L5K': { zone: 'DELIVERY $18', fee: 18 },
    'L5L': { zone: 'DELIVERY $18', fee: 18 },
    'L5M': { zone: 'DELIVERY $18', fee: 18 },
    'L5N': { zone: 'DELIVERY $18', fee: 18 },
    'L5P': { zone: 'DELIVERY $18', fee: 18 },
    'L5R': { zone: 'DELIVERY $18', fee: 18 },
    'L5S': { zone: 'DELIVERY $18', fee: 18 },
    'L5T': { zone: 'DELIVERY $18', fee: 18 },
    'L5V': { zone: 'DELIVERY $18', fee: 18 },
    'L5W': { zone: 'DELIVERY $18', fee: 18 },
    'L6A': { zone: 'DELIVERY $18', fee: 18 },
    'L6B': { zone: 'DELIVERY $18', fee: 18 },
    'L6C': { zone: 'DELIVERY $18', fee: 18 },
    'L6E': { zone: 'DELIVERY $18', fee: 18 },
    'L6G': { zone: 'DELIVERY $18', fee: 18 },
    'L6H': { zone: 'DELIVERY $20', fee: 20 },
    'L6J': { zone: 'DELIVERY $20', fee: 20 },
    'L6K': { zone: 'DELIVERY $20', fee: 20 },
    'L6L': { zone: 'DELIVERY $20', fee: 20 },
    'L6M': { zone: 'DELIVERY $20', fee: 20 },
    'L6P': { zone: 'DELIVERY $18', fee: 18 },
    'L6R': { zone: 'DELIVERY $18', fee: 18 },
    'L6S': { zone: 'DELIVERY $18', fee: 18 },
    'L6T': { zone: 'DELIVERY $18', fee: 18 },
    'L6V': { zone: 'DELIVERY $18', fee: 18 },
    'L6W': { zone: 'DELIVERY $18', fee: 18 },
    'L6X': { zone: 'DELIVERY $18', fee: 18 },
    'L6Y': { zone: 'DELIVERY $18', fee: 18 },
    'L6Z': { zone: 'DELIVERY $18', fee: 18 },
    'L7A': { zone: 'DELIVERY $18', fee: 18 },
    'L7B': { zone: 'DELIVERY $18', fee: 18 },
    'L7C': { zone: 'DELIVERY $20', fee: 20 },
    'L7E': { zone: 'DELIVERY $18', fee: 18 },
    'L7G': { zone: 'DELIVERY $25', fee: 25 },
    'L7L': { zone: 'DELIVERY $19', fee: 19 },
    'L7M': { zone: 'DELIVERY $19', fee: 19 },
    'L7N': { zone: 'DELIVERY $19', fee: 19 },
    'L7P': { zone: 'DELIVERY $19', fee: 19 },
    'L7R': { zone: 'DELIVERY $18', fee: 18 },
    'L7S': { zone: 'DELIVERY $19', fee: 19 },
    'L7T': { zone: 'DELIVERY $19', fee: 19 },
    'L8A': { zone: 'DELIVERY $25', fee: 25 },
    'L8B': { zone: 'DELIVERY $25', fee: 25 },
    'L8C': { zone: 'DELIVERY $25', fee: 25 },
    'L8E': { zone: 'DELIVERY $25', fee: 25 },
    'L8G': { zone: 'DELIVERY $25', fee: 25 },
    'L8H': { zone: 'DELIVERY $25', fee: 25 },
    'L8J': { zone: 'DELIVERY $25', fee: 25 },
    'L8K': { zone: 'DELIVERY $25', fee: 25 },
    'L8L': { zone: 'DELIVERY $25', fee: 25 },
    'L8M': { zone: 'DELIVERY $25', fee: 25 },
    'L8N': { zone: 'DELIVERY $25', fee: 25 },
    'L8P': { zone: 'DELIVERY $25', fee: 25 },
    'L8R': { zone: 'DELIVERY $25', fee: 25 },
    'L8S': { zone: 'DELIVERY $25', fee: 25 },
    'L8T': { zone: 'DELIVERY $25', fee: 25 },
    'L8V': { zone: 'DELIVERY $25', fee: 25 },
    'L8W': { zone: 'DELIVERY $25', fee: 25 },
    'L9G': { zone: 'DELIVERY $26', fee: 26 },
    'L9L': { zone: 'DELIVERY $25', fee: 25 },
    'L9N': { zone: 'DELIVERY $25', fee: 25 },
    'L9S': { zone: 'DELIVERY $30', fee: 30 },
    'L9T': { zone: 'DELIVERY $25', fee: 25 },
    'L9W': { zone: 'DELIVERY $26', fee: 26 },
    'M1H': { zone: 'TORONTO $14', fee: 14 },
    'M1J': { zone: 'TORONTO $14', fee: 14 },
    'M1K': { zone: 'TORONTO $14', fee: 14 },
    'M1L': { zone: 'TORONTO $13', fee: 13 },
    'M1M': { zone: 'TORONTO $14', fee: 14 },
    'M1N': { zone: 'TORONTO $13', fee: 13 },
    'M1P': { zone: 'TORONTO $14', fee: 14 },
    'M1R': { zone: 'TORONTO $14', fee: 14 },
    'M1S': { zone: 'TORONTO $14', fee: 14 },
    'M1T': { zone: 'TORONTO $14', fee: 14 },
    'M1V': { zone: 'TORONTO $14', fee: 14 },
    'M1W': { zone: 'TORONTO $14', fee: 14 },
    'M2H': { zone: 'TORONTO $14', fee: 14 },
    'M2J': { zone: 'TORONTO $14', fee: 14 },
    'M2K': { zone: 'TORONTO $14', fee: 14 },
    'M2L': { zone: 'TORONTO $14', fee: 14 },
    'M2M': { zone: 'TORONTO $14', fee: 14 },
    'M2N': { zone: 'TORONTO $14', fee: 14 },
    'M2P': { zone: 'TORONTO $14', fee: 14 },
    'M2R': { zone: 'TORONTO $14', fee: 14 },
    'M3A': { zone: 'TORONTO $14', fee: 14 },
    'M3B': { zone: 'TORONTO $14', fee: 14 },
    'M3C': { zone: 'TORONTO $14', fee: 14 },
    'M3H': { zone: 'TORONTO $14', fee: 14 },
    'M3J': { zone: 'TORONTO $14', fee: 14 },
    'M3K': { zone: 'TORONTO $14', fee: 14 },
    'M3L': { zone: 'TORONTO $14', fee: 14 },
    'M3M': { zone: 'TORONTO $14', fee: 14 },
    'M3N': { zone: 'TORONTO $14', fee: 14 },
    'M4A': { zone: 'DELIVERY $16', fee: 16 },
    'M4B': { zone: 'TORONTO $13', fee: 13 },
    'M4C': { zone: 'TORONTO $13', fee: 13 },
    'M4E': { zone: 'TORONTO $13', fee: 13 },
    'M4G': { zone: 'TORONTO $14', fee: 14 },
    'M4H': { zone: 'TORONTO $14', fee: 14 },
    'M4J': { zone: 'TORONTO $13', fee: 13 },
    'M4K': { zone: 'TORONTO $13', fee: 13 },
    'M4L': { zone: 'TORONTO $13', fee: 13 },
    'M4M': { zone: 'BERRY BLUSH Neighbourhood Rate', fee: 5 },
    'M4N': { zone: 'TORONTO $14', fee: 14 },
    'M4P': { zone: 'TORONTO $14', fee: 14 },
    'M4R': { zone: 'TORONTO $14', fee: 14 },
    'M4S': { zone: 'BERRY BLUSH Neighbourhood Rate', fee: 5 },
    'M4T': { zone: 'TORONTO $14', fee: 14 },
    'M4V': { zone: 'TORONTO $14', fee: 14 },
    'M4W': { zone: 'TORONTO $13', fee: 13 },
    'M4X': { zone: 'TORONTO $13', fee: 13 },
    'M4Y': { zone: 'TORONTO $13', fee: 13 },
    'M5A': { zone: 'TORONTO $13', fee: 13 },
    'M5B': { zone: 'TORONTO $13', fee: 13 },
    'M5C': { zone: 'TORONTO $13', fee: 13 },
    'M5E': { zone: 'TORONTO $13', fee: 13 },
    'M5G': { zone: 'TORONTO $13', fee: 13 },
    'M5H': { zone: 'TORONTO $13', fee: 13 },
    'M5J': { zone: 'TORONTO $13', fee: 13 },
    'M5K': { zone: 'DELIVERY $16', fee: 16 },
    'M5M': { zone: 'TORONTO $14', fee: 14 },
    'M5N': { zone: 'TORONTO $14', fee: 14 },
    'M5P': { zone: 'TORONTO $14', fee: 14 },
    'M5R': { zone: 'TORONTO $13', fee: 13 },
    'M5S': { zone: 'TORONTO $13', fee: 13 },
    'M5T': { zone: 'TORONTO $13', fee: 13 },
    'M5V': { zone: 'TORONTO $13', fee: 13 },
    'M6A': { zone: 'TORONTO $14', fee: 14 },
    'M6B': { zone: 'TORONTO $14', fee: 14 },
    'M6C': { zone: 'TORONTO $14', fee: 14 },
    'M6E': { zone: 'TORONTO $14', fee: 14 },
    'M6G': { zone: 'TORONTO $13', fee: 13 },
    'M6H': { zone: 'TORONTO $13', fee: 13 },
    'M6J': { zone: 'TORONTO $13', fee: 13 },
    'M6K': { zone: 'TORONTO $13', fee: 13 },
    'M6L': { zone: 'TORONTO $14', fee: 14 },
    'M6M': { zone: 'TORONTO $14', fee: 14 },
    'M6N': { zone: 'TORONTO $14', fee: 14 },
    'M6P': { zone: 'TORONTO $14', fee: 14 },
    'M6R': { zone: 'TORONTO $13', fee: 13 },
    'M6S': { zone: 'TORONTO $14', fee: 14 },
    'M8V': { zone: 'DELIVERY $16', fee: 16 },
    'M8W': { zone: 'DELIVERY $16', fee: 16 },
    'M8X': { zone: 'TORONTO $14', fee: 14 },
    'M8Y': { zone: 'TORONTO $14', fee: 14 },
    'M8Z': { zone: 'DELIVERY $16', fee: 16 },
    'M9A': { zone: 'TORONTO $14', fee: 14 },
    'M9B': { zone: 'DELIVERY $16', fee: 16 },
    'M9C': { zone: 'DELIVERY $16', fee: 16 },
    'M9L': { zone: 'DELIVERY $16', fee: 16 },
    'M9M': { zone: 'DELIVERY $16', fee: 16 },
    'M9N': { zone: 'TORONTO $14', fee: 14 },
    'M9P': { zone: 'TORONTO $14', fee: 14 },
    'M9R': { zone: 'TORONTO $14', fee: 14 },
    'M9V': { zone: 'DELIVERY $16', fee: 16 },
    'M9W': { zone: 'DELIVERY $16', fee: 16 },
  };
  function lookupShipping(postal){
    var prefix = (postal || '').replace(/\s/g, '').substring(0, 3).toUpperCase();
    return POSTAL_ZONES[prefix] || null;
  }
  var ICONS = {
    bouquet:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="12" cy="8" r="3"/><circle cx="7" cy="11" r="2.4"/><circle cx="17" cy="11" r="2.4"/><path d="M12 11v9M9 20h6"/></svg>',
    addon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><rect x="6" y="9" width="12" height="11" rx="1"/><path d="M9 9V7a3 3 0 016 0v2"/></svg>'
  };
  function escapeAttr(str){
    return String(str).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
  }
  function thumbMarkup(item, icon){
    if(item.image){
      return '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.name) + '" loading="lazy">';
    }
    return icon;
  }
  var OCCASIONS = ['Anniversary', 'Birthday', 'Congrats!', 'Get well soon', 'Housewarming', 'Just because', 'Newborn', 'Sympathy', 'Thank you / Gratitude', 'Other'];
  var PICKUP_LOCATIONS = [
    { id:'queen', name:'Queen St E', address:'1112 Queen St E, Toronto, ON M4M 1K8', phone:'(647) 877-6848' },
    { id:'yonge', name:'Yonge St', address:'1960 Yonge St Unit 101, Toronto, ON M5P 1B9', phone:'(647) 267-6848' }
  ];
  function customDatesTarget(){
    if(state.subType === 'Classic Subscription') return 1;
    return (state.count && state.count.n) || TIERS[TIERS.length - 1].n;
  }

  var state = { bouquet:null, addons:{}, subType:null, freq:null, freqId:null, freqDiscount:0, count:null, customDates:[] };

  // RESUME EDITING (2026-10-03): once a Custom Subscription (Blush Dates) order
  // is in the cart, there was previously no way back to the card-message/date
  // fields short of restarting the whole wizard. We now save a snapshot of the
  // order to sessionStorage right after it's added to the cart (including the
  // cart line `key`s Shopify assigned), and offer a "Edit that order" banner on
  // reload. Resuming restores `state` and rebuilds the delivery rows straight
  // on the 'dates' screen; resubmitting removes the old cart lines (via
  // /cart/change.js) before adding the corrected ones. Classic Subscription
  // orders don't carry a card note, so this only applies to Custom Subscription.
  var RESUME_KEY = 'bbResumeEditSnapshot';
  var resumeLineKeys = null;
  var deliveryRowSeq = 0;

  function saveResumeSnapshot(lineKeys){
    try {
      sessionStorage.setItem(RESUME_KEY, JSON.stringify({
        subType: state.subType,
        bouquet: state.bouquet,
        addons: state.addons,
        freq: state.freq,
        freqId: state.freqId,
        freqDiscount: state.freqDiscount,
        count: state.count,
        customDates: state.customDates,
        lineKeys: lineKeys || []
      }));
    } catch(e){ /* sessionStorage unavailable (e.g. private browsing) — resume-editing just won't be offered */ }
  }
  function clearResumeSnapshot(){
    try { sessionStorage.removeItem(RESUME_KEY); } catch(e){}
    resumeLineKeys = null;
  }
  function loadResumeSnapshot(){
    try {
      var raw = sessionStorage.getItem(RESUME_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch(e){ return null; }
  }
  function resumeEditing(snapshot){
    state = {
      bouquet: snapshot.bouquet,
      addons: snapshot.addons || {},
      subType: snapshot.subType,
      freq: snapshot.freq,
      freqId: snapshot.freqId,
      freqDiscount: snapshot.freqDiscount || 0,
      count: snapshot.count,
      customDates: []
    };
    resumeLineKeys = snapshot.lineKeys || [];
    history = ['blooms', 'style', 'count', 'dates'];
    window.history.replaceState({ bbSteps: history.slice() }, '');
    document.getElementById('dateList').innerHTML = '';
    (snapshot.customDates || []).forEach(function(d){ addDateRow(d); });
    document.getElementById('resumeEditBanner').hidden = true;
    showScreen('dates');
  }

  var STEPS_CLASSIC = [
    { id:'blooms', label:'Your size' },
    { id:'extras', label:'Little extras' },
    { id:'style', label:'Your style' },
    { id:'rhythm', label:'Your rhythm' },
    { id:'dates', label:'Delivery details' }
  ];
  var STEPS_CUSTOM = [
    { id:'blooms', label:'Your size' },
    { id:'extras', label:'Little extras' },
    { id:'style', label:'Your style' },
    { id:'count', label:'Deliveries' },
    { id:'dates', label:'Pick dates' },
    { id:'review', label:'Review' }
  ];

  var history = ['blooms'];

  function activeSteps(){
    return state.subType === 'Custom Subscription' ? STEPS_CUSTOM : STEPS_CLASSIC;
  }

  function renderStepper(currentId){
    var steps = activeSteps();
    var idx = steps.findIndex(function(s){ return s.id === currentId; });
    if(idx === -1) idx = steps.length;
    var html = '';
    steps.forEach(function(s, i){
      var cls = 'step-dot';
      if(i === idx) cls += ' active';
      else if(i < idx) cls += ' done';
      html += '<div class="' + cls + '"><div class="circle">' + (i+1) + '</div><div class="label">' + s.label + '</div></div>';
    });
    document.getElementById('stepper').innerHTML = html;
  }

  var NEXT_LABEL = {
    blooms: 'Next · Little extras →',
    extras: 'Continue →',
    style: 'Continue →',
    rhythm: 'Review my subscription →',
    count: 'Next · Pick dates →',
    dates: 'Review my subscription →',
    review: 'Add subscription to cart →'
  };
  function nextLabelFor(id){
    return NEXT_LABEL[id] || 'Continue →';
  }

  function showScreen(id){
    document.querySelectorAll('.screen').forEach(function(s){ s.classList.remove('visible'); });
    document.querySelector('.screen[data-screen="' + id + '"]').classList.add('visible');
    document.getElementById('backBtn').classList.toggle('visible', history.length > 1);
    document.getElementById('nextBtn').textContent = nextLabelFor(id);
    document.getElementById('nextBtn').style.display = id === 'review' ? 'none' : 'block';
    if(id === 'count'){
      document.getElementById('countHint').textContent = "Choose how many deliveries you'd like — you'll pick each date next.";
    }
    if(id === 'dates'){
      var isClassic = state.subType === 'Classic Subscription';
      document.getElementById('datesTitle').textContent = isClassic ? 'When should we start?' : 'Pick your dates';
      document.getElementById('datesHint').textContent = isClassic
        ? "You'll confirm delivery or pickup, your address, and contact details at checkout — that covers every future delivery for this subscription. Just pick a start date here."
        : 'You picked ' + customDatesTarget() + ' deliveries — add a date (and who it\'s for, if that changes) for each one.';
      document.getElementById('addDateBtn').style.display = isClassic ? 'none' : '';
      document.querySelector('.bb-wizard').classList.toggle('bb-classic-dates', isClassic);
      if(isClassic && !document.querySelectorAll('#dateList .delivery-row').length) addDateRow();
    }
    var stepsForEyebrow = activeSteps();
    var eyebrowIdx = stepsForEyebrow.findIndex(function(s){ return s.id === id; });
    var eyebrowEl = document.querySelector('.screen[data-screen="' + id + '"] .step-eyebrow');
    if(eyebrowEl){
      eyebrowEl.textContent = id === 'review' ? 'Review' : 'Step ' + String(eyebrowIdx + 1).padStart(2, '0');
    }
    renderStepper(id);
    validateStep(id);
    updateLiveBar();
  }

   function goTo(id){
    history.push(id);
    window.history.pushState({ bbSteps: history.slice() }, '');
    showScreen(id);
  }

  window.addEventListener('popstate', function(e){
    if(!e.state || !e.state.bbSteps) return;
    history = e.state.bbSteps.slice();
    showScreen(history[history.length - 1]);
  });

  document.getElementById('backBtn').addEventListener('click', function(){
    if(history.length > 1){
           window.history.back();
    }
  });

  document.getElementById('startAgain').addEventListener('click', function(){
    state = { bouquet:null, addons:{}, subType:null, freq:null, freqId:null, freqDiscount:0, count:null, customDates:[] };
    history = ['blooms'];
        window.history.replaceState({ bbSteps: ['blooms'] }, '');
    document.querySelectorAll('.bb-card, .style-card, .option-card').forEach(function(c){ c.classList.remove('selected'); });
    document.querySelectorAll('.recur-btn').forEach(function(b){ b.classList.remove('active'); });
    document.getElementById('dateList').innerHTML = '';
    document.getElementById('cartError').textContent = '';
    document.getElementById('cartError').classList.remove('visible');
    clearResumeSnapshot();
    document.getElementById('resumeEditBanner').hidden = true;
    showScreen('blooms');
  });

  (function initResumeBanner(){
    var snapshot = loadResumeSnapshot();
    if(!snapshot || !snapshot.customDates || !snapshot.customDates.length) return;
    var banner = document.getElementById('resumeEditBanner');
    banner.hidden = false;
    document.getElementById('resumeEditBtn').addEventListener('click', function(){
      resumeEditing(snapshot);
    });
    document.getElementById('dismissResumeBtn').addEventListener('click', function(){
      banner.hidden = true;
    });
  })();

  function buildCarousel(trackId, counterId, items, renderCard){
    var track = document.getElementById(trackId);
    var carousel = track.closest('.carousel');
    var counter = document.getElementById(counterId);
    var prevBtn = carousel.querySelector('[data-dir="-1"]');
    var nextBtn = carousel.querySelector('[data-dir="1"]');

    if(!items || !items.length){
      track.innerHTML = '';
      var warn = document.createElement('div');
      warn.className = 'bb-empty-collection-warning';
      warn.style.cssText = 'padding:16px;font-size:12px;color:#8C4453;border:1.5px dashed #E9E1E2;border-radius:12px;';
      warn.textContent = 'No products found. In the theme customizer, check that this section\'s collection setting points to a collection with published products.';
      track.appendChild(warn);
      counter.textContent = '0 / 0';
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    track.innerHTML = '';
    items.forEach(function(item, i){
      var card = renderCard(item, i);
      track.appendChild(card);
    });

    function currentIndex(){
      if(!track.firstElementChild) return 0;
      var cardW = track.firstElementChild.getBoundingClientRect().width + 12;
      return Math.round(track.scrollLeft / cardW);
    }
    function updateCounter(){
      var idx = Math.min(items.length - 1, Math.max(0, currentIndex()));
      counter.textContent = (idx + 1) + ' / ' + items.length + ' · Swipe';
      prevBtn.disabled = idx === 0;
      nextBtn.disabled = idx === items.length - 1;
    }
    track.addEventListener('scroll', function(){
      clearTimeout(track._t);
      track._t = setTimeout(updateCounter, 60);
    });
    prevBtn.addEventListener('click', function(){
      if(!track.firstElementChild) return;
      var cardW = track.firstElementChild.getBoundingClientRect().width + 12;
      track.scrollBy({ left: -cardW, behavior:'smooth' });
    });
    nextBtn.addEventListener('click', function(){
      if(!track.firstElementChild) return;
      var cardW = track.firstElementChild.getBoundingClientRect().width + 12;
      track.scrollBy({ left: cardW, behavior:'smooth' });
    });
    updateCounter();
  }

  function renderBloomCard(b, bIndex){
    var card = document.createElement('div');
    card.className = 'bb-card';
    card.dataset.id = b.id;
    card.innerHTML =
      '<div class="bb-thumb">' + thumbMarkup(b, ICONS.bouquet) + '</div>' +
      '<div class="bb-card-body">' +
        '<span class="name">' + b.name + '</span>' +
        '<span class="desc">' + b.desc + '</span>' +
        '<span class="price">From $' + b.price.toFixed(2) + ' <span class="unit">per delivery</span></span>' +
        '<button type="button" class="choose-btn">Choose</button>' +
      '</div>';
    card.querySelector('.choose-btn').addEventListener('click', function(){
      state.bouquet = { id:b.id, name:b.name, price:b.price, variantId:b.variantId, image:b.image, sellingPlans:b.sellingPlans };
      state.bouquetIndex = bIndex;
      document.querySelectorAll('#track-blooms .bb-card').forEach(function(c){
        c.classList.toggle('selected', c.dataset.id === b.id);
        c.querySelector('.choose-btn').textContent = c.dataset.id === b.id ? 'Selected' : 'Choose';
      });
      validateStep('blooms');
      updateLiveBar();
    });
    return card;
  }
  buildCarousel('track-blooms', 'counter-blooms', BOUQUETS, renderBloomCard);

  function renderAddonCard(a){
    var card = document.createElement('div');
    card.className = 'bb-card bb-addon-card';
    card.dataset.id = a.id;
    var showFirst = a.allowFirst !== false;
    var showEvery = a.allowEvery !== false;
    var recurButtons = '';
    if(showFirst) recurButtons += '<button type="button" class="recur-btn" data-recur="first">First delivery</button>';
    if(showEvery) recurButtons += '<button type="button" class="recur-btn" data-recur="every">Every delivery</button>';
    // Scent/option picker — only shown when the product actually has more
    // than one variant (Shopify gives every product at least one "Default
    // Title" variant, so a.variants.length <= 1 means there's nothing to
    // choose between and the picker would just be noise). Built as a
    // trigger button + popover list (like the delivery date picker) rather
    // than a native <select>, since a native dropdown's open option list is
    // rendered by the OS/browser and can't be restyled to match the theme.
    var hasOptions = a.variants && a.variants.length > 1;
    var defaultIndex = 0;
    if(hasOptions){
      for(var vi = 0; vi < a.variants.length; vi++){
        if(a.variants[vi].id === a.variantId){ defaultIndex = vi; break; }
      }
    }
    var optionHtml = '';
    if(hasOptions){
      var itemsHtml = '';
      a.variants.forEach(function(v, i){
        var isSelected = i === defaultIndex;
        var thumb = v.image ? '<img class="addon-variant-thumb" src="' + v.image + '" alt="" loading="lazy">' : '';
        itemsHtml +=
          '<button type="button" class="addon-variant-item' + (isSelected ? ' selected' : '') + '" data-index="' + i + '"' + (v.available === false ? ' disabled' : '') + '>' +
            '<span class="addon-variant-item-main">' + thumb + '<span>' + v.title + (v.available === false ? ' (Sold out)' : '') + '</span></span>' +
            (isSelected ? '<svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>' : '') +
          '</button>';
      });
      var defaultThumb = a.variants[defaultIndex].image ? '<img class="addon-variant-field-thumb" src="' + a.variants[defaultIndex].image + '" alt="">' : '';
      optionHtml =
        '<div class="addon-variant-wrap">' +
          '<button type="button" class="addon-variant-field"><span class="addon-variant-field-main">' + defaultThumb + '<span class="addon-variant-field-text">' + a.variants[defaultIndex].title + '</span></span>' +
            '<svg class="chevron-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' +
          '</button>' +
          '<div class="addon-variant-pop" hidden>' + itemsHtml + '</div>' +
        '</div>';
    }
    card.innerHTML =
      '<div class="bb-thumb">' + thumbMarkup(a, ICONS.addon) + '</div>' +
      '<div class="bb-card-body">' +
        '<span class="name">' + a.name + '</span>' +
        '<span class="price">$' + a.price.toFixed(2) + '</span>' +
        optionHtml +
        '<div class="recur-row">' + recurButtons + '</div>' +
      '</div>';
    // Tracks whichever variant is currently picked in the popover (or the
    // product's only variant when there's no choice to make), so a recur
    // button click always adds the right one.
    var selectedVariant = hasOptions ? a.variants[defaultIndex] : { id:a.variantId, blushDatesVariantId:a.blushDatesVariantId || null };
    var fieldBtn = card.querySelector('.addon-variant-field');
    var fieldText = card.querySelector('.addon-variant-field-text');
    var pop = card.querySelector('.addon-variant-pop');
    if(fieldBtn){
      fieldBtn.addEventListener('click', function(e){
        e.stopPropagation();
        var isOpen = !pop.hidden;
        closeOpenPop();
        if(!isOpen){
          pop.hidden = false;
          fieldBtn.classList.add('open');
          openPop = pop;
          var rect = fieldBtn.getBoundingClientRect();
          // Wide enough for the bigger thumbnail + a two-line name without
          // clipping (e.g. "Birthday Dog Squad (Sold out)"), capped so it
          // doesn't run off narrow cards.
          var popWidth = Math.min(Math.max(rect.width, 240), window.innerWidth - 24);
          var left = Math.min(rect.left, window.innerWidth - popWidth - 12);
          var top = rect.bottom + 6;
          var estimatedPopHeight = Math.min(280, 60 * a.variants.length);
          if(top + estimatedPopHeight > window.innerHeight - 12){
            top = Math.max(12, rect.top - estimatedPopHeight - 6);
          }
          pop.style.left = left + 'px';
          pop.style.top = top + 'px';
          pop.style.width = popWidth + 'px';
        }
      });
      pop.querySelectorAll('.addon-variant-item').forEach(function(item){
        item.addEventListener('click', function(e){
          e.stopPropagation();
          if(item.disabled) return;
          var idx = parseInt(item.dataset.index, 10);
          selectedVariant = a.variants[idx];
          fieldText.textContent = selectedVariant.title;
          var fieldThumb = fieldBtn.querySelector('.addon-variant-field-thumb');
          if(selectedVariant.image){
            if(fieldThumb){ fieldThumb.src = selectedVariant.image; }
            else { fieldText.insertAdjacentHTML('beforebegin', '<img class="addon-variant-field-thumb" src="' + selectedVariant.image + '" alt="">'); }
          } else if(fieldThumb){
            fieldThumb.remove();
          }
          pop.querySelectorAll('.addon-variant-item').forEach(function(it){
            it.classList.remove('selected');
            var existingCheck = it.querySelector('.check-icon');
            if(existingCheck) existingCheck.remove();
          });
          item.classList.add('selected');
          item.insertAdjacentHTML('beforeend', '<svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>');
          closeOpenPop();
          // If this add-on is already active, update the stored selection
          // immediately rather than waiting for the person to re-click a
          // recur button.
          if(state.addons[a.name]){
            state.addons[a.name].variantId = selectedVariant.id;
            state.addons[a.name].blushDatesVariantId = selectedVariant.blushDatesVariantId || null;
          }
        });
      });
    }
    card.querySelectorAll('.recur-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var alreadyActive = btn.classList.contains('active');
        card.querySelectorAll('.recur-btn').forEach(function(b){ b.classList.remove('active'); });
        if(alreadyActive){
          delete state.addons[a.name];
        } else {
          btn.classList.add('active');
          state.addons[a.name] = { price:a.price, recur: btn.dataset.recur, variantId:selectedVariant.id, blushDatesVariantId:selectedVariant.blushDatesVariantId || null };
        }
        updateNextLabelForExtras();
        updateLiveBar();
      });
    });
    return card;
  }
  buildCarousel('track-extras', 'counter-extras', ADDONS, renderAddonCard);

  function updateNextLabelForExtras(){
    var n = Object.keys(state.addons).length;
    var btn = document.getElementById('nextBtn');
    if(document.querySelector('.screen[data-screen="extras"]').classList.contains('visible')){
      btn.textContent = n > 0 ? ('Continue with ' + n + ' extra' + (n > 1 ? 's' : '') + ' →') : 'Continue →';
    }
  }
  document.getElementById('skipExtras').addEventListener('click', function(){
    state.addons = {};
    document.querySelectorAll('#track-extras .recur-btn').forEach(function(b){ b.classList.remove('active'); });
    goTo('style');
  });

  document.querySelectorAll('.style-card').forEach(function(card){
    card.addEventListener('click', function(){
      state.subType = card.dataset.subType;
      if(state.bouquet && typeof state.bouquetIndex === 'number'){
        if(state.subType === 'Custom Subscription' && BOUQUETS_CUSTOM.length){
          var cb = BOUQUETS_CUSTOM[state.bouquetIndex];
          if(cb){
            state.bouquet.id = cb.id;
            state.bouquet.variantId = cb.variantId;
            state.bouquet.price = cb.price;
            state.bouquet.image = cb.image;
            state.bouquet.sellingPlans = null;
          }
        } else if(state.subType === 'Classic Subscription' && BOUQUETS[state.bouquetIndex]){
          var ob = BOUQUETS[state.bouquetIndex];
          state.bouquet.id = ob.id;
          state.bouquet.variantId = ob.variantId;
          state.bouquet.price = ob.price;
          state.bouquet.image = ob.image;
          state.bouquet.sellingPlans = ob.sellingPlans;
        }
      }
      document.querySelectorAll('.style-card').forEach(function(c){ c.classList.remove('selected'); });
      card.classList.add('selected');
      validateStep('style');
      updateLiveBar();
    });
  });

  function buildList(containerId, items, renderFn){
    var container = document.getElementById(containerId);
    container.innerHTML = '';
    items.forEach(function(item, i){ container.appendChild(renderFn(item, i)); });
  }

  function renderFreqCard(f){
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'style-card';
    card.dataset.id = f.id;
    card.innerHTML =
      '<span class="eyebrow">' + f.eyebrow + ' · Save ' + Math.round(f.discount * 100) + '%</span>' +
      '<span class="title">' + f.name + '</span>' +
      '<span class="desc">' + f.desc + '</span>' +
      '<span class="stack-price" data-freq-price></span>';
    card.addEventListener('click', function(){
      document.querySelectorAll('#list-rhythm .style-card').forEach(function(c){ c.classList.remove('selected'); });
      card.classList.add('selected');
      state.freq = f.name;
      state.freqId = f.id;
      state.freqDiscount = f.discount;
      validateStep('rhythm');
      updateLiveBar();
    });
    return card;
  }

  function renderTierCard(t){
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'style-card';
    card.dataset.id = t.n;
    card.innerHTML =
      '<span class="eyebrow">' + t.eyebrow + '</span>' +
      '<span class="title">' + t.n + ' deliveries</span>' +
      '<span class="desc">Billed at the Monthly rate, whichever dates you choose</span>' +
      '<span class="stack-price" data-tier-price></span>';
    card.addEventListener('click', function(){
      document.querySelectorAll('#list-count .style-card').forEach(function(c){ c.classList.remove('selected'); });
      card.classList.add('selected');
      state.count = { n:t.n };
      validateStep('count');
      updateLiveBar();
    });
    return card;
  }

  buildList('list-rhythm', FREQUENCIES, renderFreqCard);
  buildList('list-count', TIERS, renderTierCard);

  function updateTierPrices(){
    if(!state.bouquet) return;
    var each = state.bouquet.price + addonsEveryTotal();
    document.querySelectorAll('#list-count .style-card').forEach(function(card){
      card.querySelector('[data-tier-price]').textContent = '$' + each.toFixed(2) + ' per arrangement (' + Math.round(BLUSH_DATES_DISCOUNT * 100) + '% discount)';
    });
  }
  function updateFreqPrices(){
    if(!state.bouquet) return;
    var everyUnit = state.bouquet.price + addonsEveryTotal();
    document.querySelectorAll('#list-rhythm .style-card').forEach(function(card, i){
      var f = FREQUENCIES[i];
      var each = everyUnit * (1 - f.discount);
      card.querySelector('[data-freq-price]').textContent = '$' + each.toFixed(2) + ' per delivery';
    });
  }

  var openPop = null;
  function closeOpenPop(){
    if(openPop){ openPop.hidden = true; openPop = null; }
    document.querySelectorAll('.date-field.open, .addon-variant-field.open').forEach(function(f){ f.classList.remove('open'); });
  }
  document.addEventListener('click', function(e){
    if(!e.target.closest('.date-field-wrap') && !e.target.closest('.addon-variant-wrap')) closeOpenPop();
  });
  // Capture-phase so scrolling any scrollable ancestor (the step screen,
  // the page) closes a popover whose position:fixed coordinates would
  // otherwise go stale. But the popover list ITSELF scrolls this way too
  // (addon-variant-pop / calendar-pop both use overflow-y:auto), and that
  // scroll event's target is the popover element — closing on that meant
  // the variant picker slammed shut the instant someone scrolled through
  // a long option list. Only close when the scroll happened somewhere
  // other than the open popover.
  document.addEventListener('scroll', function(e){
    if(openPop && e.target === openPop) return;
    closeOpenPop();
  }, true);
  function formatDate(d){
    return d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric', year:'numeric' });
  }
  function buildCalendar(pop, view, selected, onPick, isDisabled){
    var monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    pop.innerHTML =
      '<div class="cal-header">' +
        '<button type="button" class="cal-nav" data-dir="-1">‹</button>' +
        '<span class="cal-month">' + monthNames[view.month] + ' ' + view.year + '</span>' +
        '<button type="button" class="cal-nav" data-dir="1">›</button>' +
      '</div>' +
      '<div class="cal-weekdays"><span>S</span><span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span></div>' +
      '<div class="cal-days"></div>';
    var daysEl = pop.querySelector('.cal-days');
    var firstOfMonth = new Date(view.year, view.month, 1);
    var startOffset = firstOfMonth.getDay();
    var daysInMonth = new Date(view.year, view.month + 1, 0).getDate();
    var today = new Date(); today.setHours(0,0,0,0);
    for(var i = 0; i < startOffset; i++){
      var empty = document.createElement('span');
      empty.className = 'cal-day empty';
      daysEl.appendChild(empty);
    }
    for(var d = 1; d <= daysInMonth; d++){
      var dateObj = new Date(view.year, view.month, d);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cal-day';
      btn.textContent = d;
      if(dateObj < today || (isDisabled && isDisabled(dateObj))) btn.disabled = true;
      if(selected && dateObj.toDateString() === selected.toDateString()) btn.classList.add('selected');
      (function(dateObj){ btn.addEventListener('click', function(){ onPick(dateObj); }); })(dateObj);
      daysEl.appendChild(btn);
    }
    pop.querySelectorAll('.cal-nav').forEach(function(nav){
      nav.addEventListener('click', function(e){
        e.stopPropagation();
        view.month += parseInt(nav.dataset.dir);
        if(view.month < 0){ view.month = 11; view.year--; }
        if(view.month > 11){ view.month = 0; view.year++; }
        buildCalendar(pop, view, selected, onPick, isDisabled);
      });
    });
  }
  function renumberDeliveryRows(){
    document.querySelectorAll('#dateList .delivery-row').forEach(function(row, i){
      row.dataset.n = i + 1;
      updateDeliveryTitle(row);
    });
  }
  function updateDeliveryTitle(row){
    var titleEl = row.querySelector('.delivery-title');
    var label = state.subType === 'Classic Subscription' ? 'First delivery' : ('Delivery #' + row.dataset.n);
    if(row.dataset.niceDate) label += ' — ' + row.dataset.niceDate;
    else label += ' <span class="placeholder">— select a date</span>';
    if(row.dataset.recipient) label += ' · ' + row.dataset.recipient;
    titleEl.innerHTML = label;
  }
  function updateAddDateBtnState(){
    var btn = document.getElementById('addDateBtn');
    var target = customDatesTarget();
    var count = document.querySelectorAll('#dateList .delivery-row').length;
    if(count >= target){
      btn.disabled = true;
      btn.textContent = 'All ' + target + ' delivery dates added';
    } else {
      btn.disabled = false;
      btn.textContent = '+ Add delivery date (' + count + '/' + target + ')';
    }
  }
  function addDateRow(prefill){
    if(document.querySelectorAll('#dateList .delivery-row').length >= customDatesTarget()) return;
    var list = document.getElementById('dateList');
    document.querySelectorAll('#dateList .delivery-row').forEach(function(r){ r.classList.remove('expanded'); });

    var row = document.createElement('div');
    row.className = 'delivery-row expanded';
    // Unique id prefix for this row's fields, so each <label for="..."> below
    // can point at its own input even though addDateRow() runs more than once
    // on the same page (ids must be unique across the whole document). Tapping
    // a label now focuses its field — previously labels were purely visual, so
    // on mobile a person had to tap the small input box itself.
    var fid = 'dr' + (++deliveryRowSeq);
    var chipsHtml = OCCASIONS.map(function(o){ return '<button type="button" class="bb-chip" data-occasion="' + o + '">' + o + '</button>'; }).join('');
    row.innerHTML =
      '<button type="button" class="delivery-header">' +
        '<span class="delivery-title"></span>' +
      '</button>' +
      '<span class="row-controls">' +
        '<button type="button" class="chevron" aria-label="Expand or collapse this delivery"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></button>' +
        '<button type="button" class="remove-date" aria-label="Remove delivery">&times;</button>' +
      '</span>' +
      '<div class="delivery-body">' +
        '<label class="field-label label-fulfillment">How will they get it?</label>' +
        '<div class="fulfillment-toggle" role="group">' +
          '<button type="button" class="fulfillment-btn active" data-type="delivery">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>' +
            '<span>Delivery</span>' +
          '</button>' +
          '<button type="button" class="fulfillment-btn" data-type="pickup">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 9.5 12 4l9 5.5V19a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"/></svg>' +
            '<span>Pickup</span>' +
          '</button>' +
        '</div>' +
        '<div class="row-pickup-fields" hidden>' +
          '<label class="field-label">Pickup location</label>' +
          '<div class="pickup-location-toggle" role="group">' +
            PICKUP_LOCATIONS.map(function(loc){
              return '<button type="button" class="pickup-location-btn" data-location="' + loc.id + '">' + loc.name + '</button>';
            }).join('') +
          '</div>' +
          '<p class="pickup-address-note row-pickup-address"></p>' +
        '</div>' +
        '<label class="field-label row-date-label">Delivery date</label>' +
        '<div class="date-field-wrap">' +
          '<button type="button" class="date-field">' +
            '<span class="date-field-text">Select a date</span>' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="5" width="18" height="16" rx="1"/><path d="M8 3v4M16 3v4M3 10h18"/></svg>' +
          '</button>' +
          '<div class="calendar-pop" hidden></div>' +
        '</div>' +
        '<label class="field-label label-recipient" for="' + fid + '-first">Recipient first name*</label>' +
        '<div class="field-pair">' +
          '<input type="text" id="' + fid + '-first" class="text-input row-first-name" placeholder="Enter recipient first name" style="margin-bottom:10px;">' +
        '</div>' +
        '<label class="field-label label-recipient" for="' + fid + '-last">Recipient last name*</label>' +
        '<div class="field-pair">' +
          '<input type="text" id="' + fid + '-last" class="text-input row-last-name" placeholder="Enter recipient last name">' +
        '</div>' +
        '<div class="row-delivery-fields">' +
          '<label class="field-label" for="' + fid + '-address">Address*</label>' +
          '<input type="text" id="' + fid + '-address" class="text-input row-address" placeholder="Type your address" style="margin-bottom:10px;">' +
          '<label class="field-label" for="' + fid + '-suite">Suite or apartment number</label>' +
          '<input type="text" id="' + fid + '-suite" class="text-input row-suite" placeholder="Enter suite or apartment number" style="margin-bottom:10px;">' +
          '<label class="field-label" for="' + fid + '-postal">Postal code*</label>' +
          '<input type="text" id="' + fid + '-postal" class="text-input row-postal" placeholder="Enter postal code">' +
          '<p class="ship-note row-ship-note">Enter a postal code to see the delivery fee for this address.</p>' +
        '</div>' +
        '<label class="field-label label-phone" for="' + fid + '-phone">Phone*</label>' +
        '<input type="tel" id="' + fid + '-phone" class="text-input row-phone" placeholder="Enter recipient phone number" style="margin-bottom:4px;">' +
        '<p class="inline-error row-field-error">Please fill in recipient name, phone, and delivery/pickup details for this delivery.</p>' +
        '<label class="field-label label-occasion">Occasion <span class="optional-tag">Optional</span></label>' +
        '<div class="bb-chip-row row-chip-row">' + chipsHtml + '</div>' +
        '<label class="field-label label-note" for="' + fid + '-note">Note to recipient <span class="optional-tag">Optional</span></label>' +
        '<div class="note-card-block">' +
          '<label class="note-skip-row"><input type="checkbox" class="row-no-card"> No card needed</label>' +
          '<textarea id="' + fid + '-note" class="note-textarea row-note-field" maxlength="220" placeholder=""></textarea>' +
          '<div class="note-counter"><span class="row-note-count">0</span>/220</div>' +
          '<label class="note-confirm-row"><input type="checkbox" class="row-note-confirm"> My note is correct, free of typos, and signed appropriately!</label>' +
        '</div>' +
      '</div>';
    list.appendChild(row);
    renumberDeliveryRows();
    updateAddDateBtnState();

    // Bring the newly-added (and now-expanded) row into view at the top.
    // The row just before it collapses the instant this one opens, which
    // otherwise leaves the person staring at wherever the "+ Add delivery
    // date" button happened to land and having to scroll back up themselves
    // to see the new row's own fields.
    if(!prefill){
      requestAnimationFrame(function(){
        row.scrollIntoView({ behavior:'smooth', block:'start' });
      });
    }

    row.querySelectorAll('.row-chip-row .bb-chip').forEach(function(chip){
      chip.addEventListener('click', function(){
        var alreadyActive = chip.classList.contains('active');
        row.querySelectorAll('.row-chip-row .bb-chip').forEach(function(c){ c.classList.remove('active'); });
        if(alreadyActive){ delete row.dataset.occasion; }
        else { chip.classList.add('active'); row.dataset.occasion = chip.dataset.occasion; }
      });
    });

    var rowErrEl = row.querySelector('.row-field-error');
    function recheckRowError(){
      if(isRowComplete(row) && rowErrEl) rowErrEl.classList.remove('visible');
      // Only start highlighting individual empty fields after the person has
      // actually tried to move on once (attemptedSubmit) — otherwise a brand
      // new, untouched row would show red borders before they've typed anything.
      if(row.dataset.attemptedSubmit === '1') markMissingFields(row);
    }

    row.dataset.fulfillmentType = 'delivery';
    var deliveryFieldsEl = row.querySelector('.row-delivery-fields');
    var pickupFieldsEl = row.querySelector('.row-pickup-fields');
    var dateLabelEl = row.querySelector('.row-date-label');
    row.querySelectorAll('.fulfillment-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var type = btn.dataset.type;
        row.dataset.fulfillmentType = type;
        row.querySelectorAll('.fulfillment-btn').forEach(function(b){ b.classList.toggle('active', b === btn); });
        deliveryFieldsEl.hidden = type !== 'delivery';
        pickupFieldsEl.hidden = type !== 'pickup';
        dateLabelEl.textContent = type === 'pickup' ? 'Pickup date' : 'Delivery date';
        if(type === 'pickup'){
          delete row.dataset.shipZone;
          row.dataset.shipFee = '0';
          if(row.dataset.pickupLocationId === 'yonge' && selected && isRowDateDisabled(selected)){
            selected = null;
            field.classList.remove('filled');
            fieldText.textContent = 'Select a date';
            delete row.dataset.iso;
            delete row.dataset.niceDate;
            updateDeliveryTitle(row);
          }
        } else {
          var zone = lookupShipping(postalInput.value);
          if(zone){ row.dataset.shipZone = zone.zone; row.dataset.shipFee = zone.fee; }
          else { delete row.dataset.shipZone; row.dataset.shipFee = '0'; }
        }
        validateStep('dates');
        syncCustomDatesFromDOM();
        updateLiveBar();
        recheckRowError();
      });
    });
    var pickupAddressEl = row.querySelector('.row-pickup-address');
    row.querySelectorAll('.pickup-location-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var loc = PICKUP_LOCATIONS.filter(function(l){ return l.id === btn.dataset.location; })[0];
        row.querySelectorAll('.pickup-location-btn').forEach(function(b){ b.classList.toggle('active', b === btn); });
        if(loc){
          row.dataset.pickupLocationId = loc.id;
          row.dataset.pickupLocationName = loc.name;
          row.dataset.pickupAddress = loc.address;
          pickupAddressEl.textContent = loc.address + ' · ' + loc.phone + (loc.id === 'yonge' ? ' · Sun 10 AM–3 PM' : '');
        }
        if(row.dataset.pickupLocationId === 'yonge' && selected && isRowDateDisabled(selected)){
          selected = null;
          field.classList.remove('filled');
          fieldText.textContent = 'Select a date';
          delete row.dataset.iso;
          delete row.dataset.niceDate;
          updateDeliveryTitle(row);
        }
        validateStep('dates');
        syncCustomDatesFromDOM();
        updateLiveBar();
        recheckRowError();
      });
    });

    row.querySelector('.row-first-name').addEventListener('input', function(e){
      row.dataset.firstName = e.target.value;
      row.dataset.recipient = (row.dataset.firstName || '') + ' ' + (row.dataset.lastName || '');
      updateDeliveryTitle(row);
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
      recheckRowError();
    });
    row.querySelector('.row-last-name').addEventListener('input', function(e){
      row.dataset.lastName = e.target.value;
      row.dataset.recipient = (row.dataset.firstName || '') + ' ' + (row.dataset.lastName || '');
      updateDeliveryTitle(row);
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
      recheckRowError();
    });
    row.querySelector('.row-address').addEventListener('input', function(e){
      row.dataset.address1 = e.target.value;
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
      recheckRowError();
    });
    row.querySelector('.row-suite').addEventListener('input', function(e){
      row.dataset.suite = e.target.value;
      syncCustomDatesFromDOM();
    });
    row.querySelector('.row-phone').addEventListener('input', function(e){
      row.dataset.phone = e.target.value;
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
      recheckRowError();
    });
    var postalInput = row.querySelector('.row-postal');
    var shipNoteEl = row.querySelector('.row-ship-note');
    postalInput.addEventListener('input', function(e){
      row.dataset.postal = e.target.value;
      var zone = lookupShipping(e.target.value);
      if(zone){
        row.dataset.shipZone = zone.zone;
        row.dataset.shipFee = zone.fee;
        shipNoteEl.textContent = zone.zone + ' · +$' + zone.fee.toFixed(2) + ' delivery fee';
        shipNoteEl.classList.add('found');
      } else {
        delete row.dataset.shipZone;
        row.dataset.shipFee = '0';
        shipNoteEl.textContent = e.target.value
          ? "We'll confirm the delivery fee for this postal code before your order ships."
          : 'Enter a postal code to see the delivery fee for this address.';
        shipNoteEl.classList.remove('found');
      }
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
      recheckRowError();
    });

    var noCardBox = row.querySelector('.row-no-card');
    var noteField = row.querySelector('.row-note-field');
    var noteCount = row.querySelector('.row-note-count');
    // These three used to only write to row.dataset.* without calling
    // syncCustomDatesFromDOM() — every other field in this row does call it,
    // which is what copies the row's dataset into state.customDates (the
    // array the Review screen actually reads from). Missing it here meant
    // editing the card note, toggling "no card needed", or confirming the
    // note — including while resuming/editing an order already in the
    // cart — updated the field on screen but the Review summary kept
    // showing the OLD note until some other field in the row happened to
    // change too and synced it as a side effect.
    noteField.addEventListener('input', function(e){
      row.dataset.note = e.target.value;
      noteCount.textContent = e.target.value.length;
      syncCustomDatesFromDOM();
    });
    noCardBox.addEventListener('change', function(e){
      row.dataset.noCardNeeded = e.target.checked ? '1' : '0';
      noteField.disabled = e.target.checked;
      if(e.target.checked){ noteField.value = ''; row.dataset.note = ''; noteCount.textContent = '0'; }
      syncCustomDatesFromDOM();
    });
    row.querySelector('.row-note-confirm').addEventListener('change', function(e){
      row.dataset.noteConfirmed = e.target.checked ? '1' : '0';
      syncCustomDatesFromDOM();
    });

    var field = row.querySelector('.date-field');
    var fieldText = row.querySelector('.date-field-text');
    var pop = row.querySelector('.calendar-pop');
    var selected = null;
    var today = new Date();
    var view = { month: today.getMonth(), year: today.getFullYear() };

    function isRowDateDisabled(dateObj){
      return false;
    }

    function pick(dateObj){
      selected = dateObj;
      fieldText.textContent = formatDate(dateObj);
      field.classList.add('filled');
      row.dataset.iso = dateObj.getFullYear() + '-' + String(dateObj.getMonth()+1).padStart(2,'0') + '-' + String(dateObj.getDate()).padStart(2,'0');
      row.dataset.niceDate = formatDate(dateObj);
      updateDeliveryTitle(row);
      buildCalendar(pop, view, selected, pick, isRowDateDisabled);
      closeOpenPop();
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
      recheckRowError();
    }
    field.addEventListener('click', function(e){
      e.stopPropagation();
      var isOpen = !pop.hidden;
      closeOpenPop();
      if(!isOpen){
        buildCalendar(pop, view, selected, pick, isRowDateDisabled);
        pop.hidden = false;
        field.classList.add('open');
        openPop = pop;
        var rect = field.getBoundingClientRect();
        var popWidth = Math.min(rect.width, 300);
        var left = Math.min(rect.left, window.innerWidth - popWidth - 12);
        var top = rect.bottom + 6;
        var estimatedPopHeight = 300;
        if(top + estimatedPopHeight > window.innerHeight - 12){
          top = Math.max(12, rect.top - estimatedPopHeight - 6);
        }
        pop.style.left = left + 'px';
        pop.style.top = top + 'px';
        pop.style.width = popWidth + 'px';
      }
    });
    row.querySelector('.delivery-header').addEventListener('click', function(){
      row.classList.toggle('expanded');
    });
    row.querySelector('.chevron').addEventListener('click', function(e){
      e.stopPropagation();
      row.classList.toggle('expanded');
    });
    row.querySelector('.remove-date').addEventListener('click', function(e){
      e.stopPropagation();
      row.remove();
      renumberDeliveryRows();
      updateAddDateBtnState();
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
    });

    if(prefill){
      // Rebuild this row's fields from a previously-submitted delivery (resume-
      // editing an order that's already in the cart) instead of requiring the
      // person to retype everything.
      row.dataset.firstName = prefill.firstName || (prefill.recipient || '').split(' ')[0] || '';
      row.dataset.lastName = prefill.lastName || (prefill.recipient || '').split(' ').slice(1).join(' ') || '';
      row.dataset.recipient = prefill.recipient || ((row.dataset.firstName || '') + ' ' + (row.dataset.lastName || ''));
      row.querySelector('.row-first-name').value = row.dataset.firstName;
      row.querySelector('.row-last-name').value = row.dataset.lastName;
      row.dataset.phone = prefill.phone || '';
      row.querySelector('.row-phone').value = row.dataset.phone;

      var prefillType = prefill.fulfillmentType === 'pickup' ? 'pickup' : 'delivery';
      row.dataset.fulfillmentType = prefillType;
      row.querySelectorAll('.fulfillment-btn').forEach(function(b){ b.classList.toggle('active', b.dataset.type === prefillType); });
      deliveryFieldsEl.hidden = prefillType !== 'delivery';
      pickupFieldsEl.hidden = prefillType !== 'pickup';
      dateLabelEl.textContent = prefillType === 'pickup' ? 'Pickup date' : 'Delivery date';

      if(prefillType === 'pickup'){
        var prefillLoc = PICKUP_LOCATIONS.filter(function(l){ return l.name === prefill.pickupLocationName; })[0];
        if(prefillLoc){
          row.dataset.pickupLocationId = prefillLoc.id;
          row.dataset.pickupLocationName = prefillLoc.name;
          row.dataset.pickupAddress = prefillLoc.address;
          row.querySelectorAll('.pickup-location-btn').forEach(function(b){ b.classList.toggle('active', b.dataset.location === prefillLoc.id); });
          pickupAddressEl.textContent = prefillLoc.address + ' · ' + prefillLoc.phone + (prefillLoc.id === 'yonge' ? ' · Sun 10 AM–3 PM' : '');
        }
      } else {
        row.dataset.address1 = prefill.address1 || '';
        row.querySelector('.row-address').value = row.dataset.address1;
        row.dataset.suite = prefill.suite || '';
        row.querySelector('.row-suite').value = row.dataset.suite;
        row.dataset.postal = prefill.postal || '';
        row.querySelector('.row-postal').value = row.dataset.postal;
        if(prefill.shipZone){
          row.dataset.shipZone = prefill.shipZone;
          row.dataset.shipFee = prefill.shipFee || 0;
          shipNoteEl.textContent = prefill.shipZone + ' · +$' + (prefill.shipFee || 0).toFixed(2) + ' delivery fee';
          shipNoteEl.classList.add('found');
        }
      }

      if(prefill.iso){
        var prefillDate = new Date(prefill.iso + 'T00:00:00');
        if(!isNaN(prefillDate.getTime())){
          view = { month: prefillDate.getMonth(), year: prefillDate.getFullYear() };
          pick(prefillDate);
        }
      }

      if(prefill.occasion){
        row.dataset.occasion = prefill.occasion;
        row.querySelectorAll('.row-chip-row .bb-chip').forEach(function(c){ c.classList.toggle('active', c.dataset.occasion === prefill.occasion); });
      }
      if(prefill.noCardNeeded){
        row.dataset.noCardNeeded = '1';
        noCardBox.checked = true;
        noteField.disabled = true;
      } else if(prefill.note){
        row.dataset.note = prefill.note;
        noteField.value = prefill.note;
        noteCount.textContent = String(prefill.note.length);
      }

      row.classList.remove('expanded');
      updateDeliveryTitle(row);
      validateStep('dates');
      syncCustomDatesFromDOM();
      updateLiveBar();
    }
  }
  document.getElementById('addDateBtn').addEventListener('click', function(){
    // If an earlier delivery row is still missing a required field, flag it
    // right here instead of letting the person move on to row #2/#3 and only
    // discovering row #1 was incomplete much later when they finally hit the
    // overall Next/Review button.
    if(revealFirstIncompleteRow()) return;
    addDateRow();
  });

  function isRowComplete(r){
    if(state.subType === 'Classic Subscription') return !!r.dataset.iso;
    var base = !!r.dataset.iso
      && !!(r.dataset.firstName && r.dataset.firstName.trim())
      && !!(r.dataset.lastName && r.dataset.lastName.trim())
      && !!(r.dataset.phone && r.dataset.phone.trim());
    if(!base) return false;
    if(r.dataset.fulfillmentType === 'pickup'){
      return !!(r.dataset.pickupLocationId && r.dataset.pickupLocationId.trim());
    }
    return !!(r.dataset.address1 && r.dataset.address1.trim())
      && !!(r.dataset.postal && r.dataset.postal.trim());
  }
  function completeDeliveryRows(){
    return Array.prototype.filter.call(document.querySelectorAll('#dateList .delivery-row'), isRowComplete);
  }
  // Highlights exactly which required field(s) on this row are still empty
  // (a red-berry border directly on the field), instead of only a generic
  // "please fill in recipient name, phone, and delivery/pickup details"
  // sentence that leaves the person hunting for which one of several fields
  // is the actual problem.
  function markMissingFields(row){
    var isPickup = row.dataset.fulfillmentType === 'pickup';
    var checks = [
      { ok: !!row.dataset.iso, el: row.querySelector('.date-field') },
      { ok: !!(row.dataset.firstName && row.dataset.firstName.trim()), el: row.querySelector('.row-first-name') },
      { ok: !!(row.dataset.lastName && row.dataset.lastName.trim()), el: row.querySelector('.row-last-name') },
      { ok: !!(row.dataset.phone && row.dataset.phone.trim()), el: row.querySelector('.row-phone') }
    ];
    if(isPickup){
      checks.push({ ok: !!(row.dataset.pickupLocationId && row.dataset.pickupLocationId.trim()), el: row.querySelector('.pickup-location-toggle') });
    } else {
      checks.push({ ok: !!(row.dataset.address1 && row.dataset.address1.trim()), el: row.querySelector('.row-address') });
      checks.push({ ok: !!(row.dataset.postal && row.dataset.postal.trim()), el: row.querySelector('.row-postal') });
    }
    checks.forEach(function(c){
      if(c.el) c.el.classList.toggle('invalid', !c.ok);
    });
  }
  function syncCustomDatesFromDOM(){
    state.customDates = Array.prototype.map.call(completeDeliveryRows(), function(r){
      var isPickup = r.dataset.fulfillmentType === 'pickup';
      return {
        iso:r.dataset.iso,
        niceDate:r.dataset.niceDate,
        occasion:r.dataset.occasion || null,
        note:r.dataset.note || '',
        noCardNeeded: r.dataset.noCardNeeded === '1',
        recipient:r.dataset.recipient || '',
        firstName:r.dataset.firstName || '',
        lastName:r.dataset.lastName || '',
        phone:r.dataset.phone || '',
        fulfillmentType: isPickup ? 'pickup' : 'delivery',
        address1: isPickup ? '' : (r.dataset.address1 || ''),
        suite: isPickup ? '' : (r.dataset.suite || ''),
        postal: isPickup ? '' : (r.dataset.postal || ''),
        shipZone: isPickup ? null : (r.dataset.shipZone || null),
        shipFee: isPickup ? 0 : (parseFloat(r.dataset.shipFee || '0') || 0),
        pickupLocationName: isPickup ? (r.dataset.pickupLocationName || '') : '',
        pickupAddress: isPickup ? (r.dataset.pickupAddress || '') : ''
      };
    });
  }

  function validateStep(id){
    var nextBtn = document.getElementById('nextBtn');
    var err = document.getElementById('error-' + id);
    var wasDisabled = nextBtn.classList.contains('is-disabled');
    var valid = true;
    if(id === 'blooms') valid = !!state.bouquet;
    if(id === 'style') valid = !!state.subType;
    if(id === 'rhythm') valid = !!state.freq;
    if(id === 'count') valid = !!state.count;
    if(id === 'dates') valid = completeDeliveryRows().length === customDatesTarget();
    // Uses a CSS class instead of the native `disabled` attribute: a truly
    // disabled button can't receive click events at all, which meant the
    // "show me which delivery/field is still missing" logic in the click
    // handler below could never actually run — the button just looked stuck
    // with zero explanation. Styling is identical either way (see .is-disabled
    // in the stylesheet above); aria-disabled keeps it accessible.
    nextBtn.classList.toggle('is-disabled', !valid);
    nextBtn.setAttribute('aria-disabled', String(!valid));
    if(err){ err.classList.remove('visible'); }
    nextBtn.dataset.blockedStep = id;
    // The instant every delivery row is filled in, Next goes from disabled
    // to enabled — on mobile this usually happens while someone is still
    // scrolled down inside the LAST row's fields, so without this they have
    // to manually hunt for the Next button afterwards. Only fires on the
    // actual disabled->enabled transition (not on every keystroke once
    // everything is already complete), and only on the 'dates' step, where
    // this was reported.
    if(id === 'dates' && valid && wasDisabled){
      requestAnimationFrame(function(){
        nextBtn.scrollIntoView({ behavior:'smooth', block:'end' });
      });
    }
  }

  // Expands + highlights the first delivery row that's still missing a
  // required field (same "which field exactly" highlighting as
  // markMissingFields()). Shared by the final Next button AND by "+ Add
  // delivery date" — previously an incomplete row #1 only ever surfaced once
  // the person reached the very end and hit Next, by which point they might
  // already be filling in row #3 with no idea row #1 was the problem.
  // Returns the row if one was found+flagged, or null if everything's complete.
  function revealFirstIncompleteRow(){
    var firstBad = Array.prototype.find.call(document.querySelectorAll('#dateList .delivery-row'), function(r){
      return !isRowComplete(r);
    });
    if(!firstBad) return null;
    document.querySelectorAll('#dateList .delivery-row').forEach(function(r){ r.classList.remove('expanded'); });
    firstBad.classList.add('expanded');
    firstBad.dataset.attemptedSubmit = '1';
    var rowErr = firstBad.querySelector('.row-field-error');
    if(rowErr) rowErr.classList.add('visible');
    markMissingFields(firstBad);
    firstBad.scrollIntoView({ behavior:'smooth', block:'center' });
    return firstBad;
  }

  document.getElementById('nextBtn').addEventListener('click', function(){
    var current = history[history.length - 1];
    var nextBtn = document.getElementById('nextBtn');
    if(nextBtn.classList.contains('is-disabled')){
      var err = document.getElementById('error-' + current);
      if(err) err.classList.add('visible');
      if(current === 'dates'){
        revealFirstIncompleteRow();
      }
      return;
    }
    if(current === 'blooms') return goTo('extras');
    if(current === 'extras') return goTo('style');
    if(current === 'style'){
      updateTierPrices();
      updateFreqPrices();
      return goTo(state.subType === 'Custom Subscription' ? 'count' : 'rhythm');
    }
    if(current === 'rhythm'){
      return goTo('dates');
    }
    if(current === 'dates'){
      syncCustomDatesFromDOM();
      renderSummary();
      return goTo('review');
    }
    if(current === 'count'){
      var rows = document.querySelectorAll('#dateList .delivery-row');
      var target = customDatesTarget();
      if(rows.length > target){
        Array.prototype.slice.call(rows, target).forEach(function(r){ r.remove(); });
        renumberDeliveryRows();
      } else if(rows.length === 0){
        addDateRow();
      }
      updateAddDateBtnState();
      return goTo('dates');
    }
  });

  // Estimated tax — computed the same way Shopify's real checkout computes
  // it: 13% HST per CART LINE (rounded to the cent on each line), summed —
  // not 13% on the lump-sum subtotal. Shopify's checkout rounds tax per
  // line item, so matching that line-by-line here keeps the Review
  // screen's total in sync with the real checkout total to the penny
  // (previously this could be off by a cent on some orders because a
  // flat subtotal × 13% rounds differently than several smaller lines
  // each rounded on their own). Line composition mirrors submitOrder()'s
  // actual cart items exactly, so the tax reflects the real line items
  // that will be added to cart (one bouquet line per delivery date, one
  // Delivery Fee line per non-pickup delivery, one line per add-on with
  // quantity = number of dates for "every delivery" add-ons).
  function calcEstimatedTax(){
    var TAX_RATE = 0.13;
    var lineAmounts = [];
    if(!state.bouquet) return 0;
    if(state.subType === 'Custom Subscription'){
      var previewCount = (state.count && state.count.n) || state.customDates.length || 1;
      var dateCount = state.customDates.length || previewCount;
      for(var i = 0; i < dateCount; i++){ lineAmounts.push(state.bouquet.price); }
      state.customDates.forEach(function(d){
        if(d.fulfillmentType !== 'pickup' && d.shipFee){ lineAmounts.push(d.shipFee); }
      });
      Object.keys(state.addons).forEach(function(k){
        var a = state.addons[k];
        var qty = a.recur === 'every' ? dateCount : 1;
        lineAmounts.push(a.price * qty);
      });
    } else if(state.freq){
      var everyUnit = state.bouquet.price;
      var each = everyUnit * (1 - (state.freqDiscount || 0));
      lineAmounts.push(each);
      Object.keys(state.addons).forEach(function(k){ lineAmounts.push(state.addons[k].price); });
    }
    var tax = 0;
    lineAmounts.forEach(function(amt){ tax += Math.round(amt * TAX_RATE * 100) / 100; });
    return Math.round(tax * 100) / 100;
  }
  function addonsEveryTotal(){
    var t = 0;
    Object.keys(state.addons).forEach(function(k){ if(state.addons[k].recur === 'every') t += state.addons[k].price; });
    return t;
  }
  function addonsFirstTotal(){
    var t = 0;
    Object.keys(state.addons).forEach(function(k){ t += state.addons[k].price; });
    return t;
  }
  function shippingTotal(){
    var t = 0;
    document.querySelectorAll('#dateList .delivery-row').forEach(function(r){
      if(r.dataset.fulfillmentType === 'pickup') return;
      t += parseFloat(r.dataset.shipFee || '0') || 0;
    });
    return t;
  }
  function currentTotal(){
    if(!state.bouquet) return 0;
    var everyUnit = state.bouquet.price + addonsEveryTotal();
    if(state.subType === 'Custom Subscription'){
      var previewCount = (state.count && state.count.n) || state.customDates.length || 1;
      return everyUnit * previewCount + addonsFirstTotal() + shippingTotal();
    }
    var each = everyUnit * (1 - (state.freqDiscount || 0));
    return each + addonsFirstTotal();
  }
  function updateLiveBar(){
    var el = document.getElementById('liveText');
    if(!state.bouquet){ el.textContent = 'Start by choosing your size'; return; }
    var text = state.bouquet.name;
    if(state.subType === 'Custom Subscription' && state.count){ text = state.count.n + ' deliveries of ' + state.bouquet.name; }
    else if(state.subType === 'Custom Subscription' && state.customDates.length){ text = state.customDates.length + ' deliveries of ' + state.bouquet.name; }
    else if(state.freq){ text = state.freq + ' · ' + state.bouquet.name; }
    var isSingleDeliveryPreview = state.subType === 'Custom Subscription' && !state.customDates.length && !state.count;
    var suffix = state.subType === 'Classic Subscription' || isSingleDeliveryPreview
      ? ' / delivery'
      : (state.subType === 'Custom Subscription' ? ' total' : '');
    el.innerHTML = text + ' · <b>$' + currentTotal().toFixed(2) + suffix + '</b>';
  }
  function renderSummary(){
    var sumBouquetLine = document.getElementById('sumBouquet').closest('.s-line');
    if(state.subType === 'Custom Subscription'){
      if(sumBouquetLine) sumBouquetLine.style.display = 'none';
    } else {
      if(sumBouquetLine) sumBouquetLine.style.display = '';
      document.getElementById('sumBouquet').textContent = state.bouquet.name;
      document.getElementById('sumBouquetPrice').textContent = '$' + state.bouquet.price.toFixed(2);
    }
    var addonLines = '';
    Object.keys(state.addons).forEach(function(k){
      var a = state.addons[k];
      addonLines += '<div class="s-line"><span>' + k + ' (' + (a.recur === 'every' ? 'every delivery' : 'first delivery only') + ')</span><span>+$' + a.price.toFixed(2) + '</span></div>';
    });
    document.getElementById('sumAddonLines').innerHTML = addonLines;
    var subTypeLabel = state.subType === 'Custom Subscription' ? 'Blush Dates' : (state.subType === 'Classic Subscription' ? 'Always in Bloom' : '—');
    document.getElementById('sumType').textContent = subTypeLabel;
    var scheduleHtml = '';
    if(state.subType === 'Custom Subscription'){
      var customEach = state.bouquet.price + addonsEveryTotal();
      state.customDates.forEach(function(d, i){
        var label = 'Delivery ' + (i+1) + ' — ' + d.niceDate + (d.occasion ? ' · ' + d.occasion : '');
        scheduleHtml += '<div class="s-line"><span>' + label + '</span><span>$' + customEach.toFixed(2) + ' (' + Math.round(BLUSH_DATES_DISCOUNT * 100) + '% discount)</span></div>';
        var isPickup = d.fulfillmentType === 'pickup';
        var toWhom = d.recipient
          ? ('To ' + d.recipient + (isPickup ? ' · Pickup' : (d.shipZone ? ' · ' + d.shipZone : ' · shipping to be confirmed')))
          : '';
        if(toWhom){
          scheduleHtml += '<div class="s-line" style="padding-left:10px;color:var(--ink-soft);font-size:10.5px;"><span>' + toWhom + '</span><span>' + (!isPickup && d.shipFee ? '+$' + d.shipFee.toFixed(2) : '') + '</span></div>';
        }
        if(isPickup && d.pickupLocationName){
          scheduleHtml += '<div class="s-line" style="padding-left:10px;color:var(--ink-soft);font-size:10.5px;"><span>Pickup — ' + d.pickupLocationName + ', ' + d.pickupAddress + '</span><span></span></div>';
        }
        if(!isPickup && d.address1){
          var addrLine = d.address1 + (d.suite ? ', Unit ' + d.suite : '') + (d.postal ? ', ' + d.postal : '');
          scheduleHtml += '<div class="s-line" style="padding-left:10px;color:var(--ink-soft);font-size:10.5px;"><span>' + addrLine + '</span><span></span></div>';
        }
        if(d.phone){
          scheduleHtml += '<div class="s-line" style="padding-left:10px;color:var(--ink-soft);font-size:10.5px;"><span>Phone: ' + d.phone + '</span><span></span></div>';
        }
        if(d.note && !d.noCardNeeded){
          var noteText = d.note.length > 40 ? (d.note.slice(0, 40) + '…') : d.note;
          scheduleHtml += '<div class="s-line" style="padding-left:10px;color:var(--ink-soft);font-size:10.5px;"><span>Note: ' + noteText + '</span><span></span></div>';
        }
      });
    } else if(state.freq){
      var everyUnit2 = state.bouquet.price + addonsEveryTotal();
      var each = everyUnit2 * (1 - (state.freqDiscount || 0));
      scheduleHtml += '<div class="s-line"><span>' + state.freq + ' delivery (−' + Math.round((state.freqDiscount || 0) * 100) + '%)</span><span>$' + each.toFixed(2) + ' each</span></div>';
      scheduleHtml += '<div class="s-line" style="padding-left:10px;color:var(--ink-soft);font-size:10.5px;"><span>Recurs until you cancel or skip</span><span></span></div>';
      var classicInfo = state.customDates[0];
      if(classicInfo && classicInfo.niceDate){
        scheduleHtml += '<div class="s-line" style="padding-left:10px;color:var(--ink-soft);font-size:10.5px;"><span>First delivery: ' + classicInfo.niceDate + '</span><span></span></div>';
      }
    }
    document.getElementById('sumScheduleLines').innerHTML = scheduleHtml;
    // Estimated tax — 13% HST, calculated per cart line the same way the
    // real checkout does (see calcEstimatedTax() above), not as a flat
    // 13% of the lump-sum subtotal. Still labeled "estimated" since
    // checkout calculates the exact amount from the real delivery address.
    var subtotal = currentTotal();
    var estTax = calcEstimatedTax();
    var sumTaxEl = document.getElementById('sumTax');
    if(sumTaxEl) sumTaxEl.textContent = '$' + estTax.toFixed(2);
    document.getElementById('sumTotal').textContent = '$' + (subtotal + estTax).toFixed(2) + (state.subType === 'Classic Subscription' ? ' / delivery' : '');
    var handoffNote = document.getElementById('checkoutHandoffNote');
    if(handoffNote) handoffNote.style.display = (state.subType === 'Custom Subscription' && state.customDates.length > 1) ? '' : 'none';
  }

  function openCheckoutNotice(){
    document.getElementById('checkoutNoticeModal').style.display = 'flex';
  }
  function closeCheckoutNotice(){
    document.getElementById('checkoutNoticeModal').style.display = 'none';
  }
  document.querySelectorAll('.js-checkout-cancel').forEach(function(btn){
    btn.addEventListener('click', closeCheckoutNotice);
  });
  document.getElementById('checkoutNoticeBackdrop').addEventListener('click', closeCheckoutNotice);
  document.querySelectorAll('.js-checkout-continue').forEach(function(btn){
    btn.addEventListener('click', function(){
      closeCheckoutNotice();
      submitOrder();
    });
  });

  document.getElementById('addToCartBtn').addEventListener('click', function(){
    if(!state.bouquet || !state.bouquet.variantId){
      showCartError("Something's not quite ready — please go back and pick your size again.");
      return;
    }
    if(state.subType === 'Custom Subscription'){
      openCheckoutNotice();
      return;
    }
    submitOrder();
  });

  function submitOrder(){
    var items = [];

    if(state.subType === 'Custom Subscription'){
      if(!state.customDates || !state.customDates.length){
        showCartError('Please add at least one delivery date first.');
        return;
      }
      var missingFeeVariant = false;
      state.customDates.forEach(function(d){
        if(missingFeeVariant) return;
        var isPickup = d.fulfillmentType === 'pickup';
        var properties = {
          'Delivery date': d.niceDate,
          'Fulfillment': isPickup ? 'Pickup' : 'Delivery',
          'Recipient': d.recipient || '',
          'Recipient phone': d.phone || '',
          'Occasion': d.occasion || '',
          'Note': d.noCardNeeded ? 'No card needed' : (d.note || '')
        };
        if(isPickup){
          properties['Pickup location'] = d.pickupLocationName || '';
          properties['Pickup address'] = d.pickupAddress || '';
        } else {
          properties['Delivery address'] = d.address1 || '';
          properties['Suite/Apt'] = d.suite || '';
          properties['Postal code'] = d.postal || '';
          properties['Delivery zone'] = d.shipZone || 'Unconfirmed — needs manual check';
          properties['Shipping fee'] = '$' + (d.shipFee || 0).toFixed(2);
        }
        items.push({
          id: state.bouquet.variantId,
          quantity: 1,
          properties: properties
        });
        if(!isPickup){
          var feeAmount = d.shipFee || 0;
          var feeVariantId = DELIVERY_FEE_VARIANTS[feeAmount];
          if(!feeVariantId){
            showCartError('Delivery fee of $' + feeAmount.toFixed(2) + ' for ' + d.niceDate + ' doesn\'t have a matching Delivery Fee variant set up yet — please check DELIVERY_FEE_VARIANTS in the wizard code / the Delivery Fee (Internal) product in Shopify admin.');
            missingFeeVariant = true;
            return;
          }
          items.push({
            id: feeVariantId,
            quantity: 1,
            properties: { '_fee_item': 'true', 'Delivery fee for': d.niceDate, 'Zone': d.shipZone || '' }
          });
        }
      });
      if(missingFeeVariant) return;
      Object.keys(state.addons).forEach(function(k){
        var a = state.addons[k];
        if(!a.variantId) return;
        // Add-ons that are ALSO sold standalone elsewhere in the store (so
        // their main variant legitimately requires real shipping) need a
        // dedicated non-shipping "Blush Dates" duplicate the same way the
        // bouquets do — set via the custom.blush_dates_product metafield on
        // the add-on product. Falls back to the regular variant for add-ons
        // that are wizard-exclusive and were never marked non-physical.
        items.push({
          id: a.blushDatesVariantId || a.variantId,
          quantity: a.recur === 'every' ? state.customDates.length : 1,
          properties: { 'Add-on for': 'Blush Dates order', 'Applies to': a.recur === 'every' ? 'every delivery' : 'first delivery only' }
        });
      });
    } else {
      var sellingPlanId = state.bouquet.sellingPlans && state.freqId ? state.bouquet.sellingPlans[state.freqId] : null;
      var classicInfo = state.customDates[0] || {};
      var classicProps = {
        'Frequency': state.freq,
        'Start date': classicInfo.niceDate || ''
      };
      if(!sellingPlanId){
        showCartError("This size doesn't have a matching subscription plan set up yet for " + (state.freq || 'this frequency') + " — please check the selling plan names in Shopify admin.");
        return;
      }
      items.push({
        id: state.bouquet.variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: classicProps
      });
      Object.keys(state.addons).forEach(function(k){
        var a = state.addons[k];
        if(!a.variantId) return;
        items.push({
          id: a.variantId,
          quantity: 1,
          properties: { 'Add-on for': 'Always in Bloom', 'Applies to': a.recur === 'every' ? 'every delivery' : 'first delivery only' }
        });
      });
    }

    var isResuming = !!(resumeLineKeys && resumeLineKeys.length);
    var addBtn = document.getElementById('addToCartBtn');
    addBtn.disabled = true;
    addBtn.textContent = isResuming ? 'Saving changes…' : 'Adding to cart…';

    // When this is a resume-edit of an order already in the cart, remove its old
    // line items first (by the cart line `key`s saved in the snapshot) so the
    // corrected delivery doesn't end up duplicated alongside the original.
    // These /cart/change.js calls are chained ONE AT A TIME (reduce over a
    // Promise chain) rather than fired together with Promise.all — Shopify's
    // cart is a single session resource, and firing several change.js/add.js
    // requests at the same moment is a known way for one of them to lose the
    // race and silently not apply, which is almost certainly why an edited
    // order was showing up duplicated instead of replacing the original.
    var removeOldLines = isResuming
      ? resumeLineKeys.reduce(function(chain, key){
          return chain.then(function(){
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        }, Promise.resolve())
      : Promise.resolve();

    removeOldLines
      .then(function(){
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function(res){
        if(!res.ok) return res.json().then(function(body){ throw new Error(body.description || 'Could not add this to your cart.'); });
        return res.json();
      })
      .then(function(data){
        // Save/refresh the resume-edit snapshot so the card message (and
        // everything else about this order) can be reopened later from the
        // cart, instead of only ever being editable right after this submit.
        // Classic Subscription has no card note, so this only applies here.
        if(state.subType === 'Custom Subscription' && data && data.items){
          var newKeys = data.items.map(function(it){ return it.key; }).filter(Boolean);
          saveResumeSnapshot(newKeys);
        }
        window.location.href = '/cart';
      })
      .catch(function(err){
        addBtn.disabled = false;
        addBtn.textContent = isResuming ? 'Save changes to cart →' : 'Add subscription to cart →';
        showCartError(err.message || 'Something went wrong adding this to your cart — please try again.');
      });
  }

  function showCartError(msg){
    var el = document.getElementById('cartError');
    if(!el) return;
    el.textContent = msg;
    el.classList.add('visible');
  }

  window.history.replaceState({ bbSteps: ['blooms'] }, '');
  showScreen('blooms');
})();

  } catch(e) { console.error(e); }
})();
})();
